import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import styled from "styled-components";
import { useHistory, useParams, Link } from "react-router-dom";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import { getThemeParams } from "../../ducks/shopping/actions";
import { themeSelector } from "../../ducks/shopping/selectors";
import { primaryColor } from "../../constants"; // , imgLogo, brandContactEmail, footerPrimaryBackground, colorParagraph, colorTitle, buttonPrimaryBackgound, buttonPrimaryText, footerSecondaryBackground, facebookLink, instagramLink

const Container = styled.div``;

const Content = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 20px;
  background-color: ${(props) => props.bgColor || "#f3f3f3"}; // express //
  min-height: 160px;
  padding-top: 40px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    justify-items: center;
    padding-bottom: 30px;
    p {
      text-align: center;
    }
  }
`;

const Logo = styled.img`
  width: 100%;
  max-height: 40px;
  object-fit: contain;
`;

const Title = styled.p`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.color || "#404040"}; // express //
  margin-top: 10px;
  margin-bottom: 10px;
  cursor: ${(props) => props.pointer};
  @media (max-width: 1200px) {
    font-size: 14px;
  }
`;

const SocialButton = styled.div`
  background-color: ${(props) => props.bgColor || primaryColor}; // express //
  width: 40px;
  height: 40px;
  border-radius: 20px;
  margin: 0px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const SocialNetworksContainer = styled.div`
  display: flex;
`;

const Info = styled.p`
  color: ${(props) => props.color || "#808080"}; // express //
  font-weight: 300;
  padding-bottom: 5px;
`;

const CopyRightContainer = styled.div`
  min-height: 60px;
  background-color: ${(props) => props.bgColor || "#e5e5e5"}; // express //

  p {
    color: #404040;
    margin-top: 5px;
    text-align: center;
  }
  @media (max-width: 420px) {
    font-size: 14px;
  }
`;

const objUrlFacebook = {
  "yoper.cl": "https://www.facebook.com/yoper.cl",
  "yoperapp.com": "https://www.facebook.com/yoper.cl",
  "yoper.com.ar": "https://www.facebook.com/yoper.com.ar",
  "yoper.com.pe": "https://www.facebook.com/yoper.com.pe",
};
const objUrlInstagram = {
  "yoper.cl": "https://www.instagram.com/yoper.cl",
  "yoperapp.com": "https://www.instagram.com/yoper.cl",
  "yoper.com.ar": "https://www.instagram.com/yoper.com.ar",
  "yoper.com.pe": "https://www.instagram.com/yoper.com.pe",
};

const urlHref = window.location.hostname !== "localhost" ? window.location.hostname : "yoper.cl";

export default function Footer() {
  const history = useHistory();
  const params = useParams();
  const dispatch = useDispatch();
  const theme = useSelector(themeSelector);
  // console.log("theme",theme);
  useEffect(() => {

    if (history && history.location && history.location.pathname.includes("/catalog")) { // is in /catalog/:id ? 
      const idBrand = params && params.idBrand;
      dispatch(getThemeParams( idBrand ));
    } 

  }, [dispatch, history]);

  return (
    <Container>
      <Content bgColor="white">
        <div>
          <Logo src={theme && theme.imgLogo || "/assets/images/yoper-header.png"} />
        </div>
        <div>
          <Title color={theme && theme.colorTitle}>Contacto</Title>

          <Info color={theme && theme.colorParagraph}>{theme && theme.brandContactEmail || "contacto@yoper.cl"}</Info>

          {/* {urlHref === "yoper.cl" ? <Info>contacto@yoper.cl</Info> : null}
          {urlHref === "yoperapp.com" ? <Info>contacto@yoper.cl</Info> : null}
          {urlHref === "yoper.com.ar" ? <Info>contacto@yoper.com.ar</Info> : null}
          {urlHref === "yoper.com.pe" ? <Info>contacto@yoper.com.pe</Info> : null} */}
        </div>

        {/* <a href={termsAndConditions} target="_blank" rel="noopener noreferrer"> */}
          <div>
            <Link to="/terms-and-conditions">
              <Title color={theme && theme.colorTitle} pointer="pointer">Términos y condiciones</Title>
            </Link>
          </div>
        {/* </a> */}

        {window.location.pathname !== "/" ? (
          <div>
            <Title
              color={theme && theme.colorTitle}
              pointer="pointer"
              onClick={() => {
                history.push(`/catalog${theme && theme.id ? `/${theme && theme.id}` : ""}/1`);
                window.scrollTo(0, 0);
              }}
            >
              Ver tiendas
            </Title>
          </div>
        ) : (
          <div />
        )}
        <SocialNetworksContainer>
          <a href={theme && theme.facebookLink || objUrlFacebook[urlHref]} target="_blank" rel="noopener noreferrer">
            <SocialButton bgColor={theme && theme.buttonPrimaryBackgound} className="opacity">
              <FaFacebookF size={22} color={theme && theme.buttonPrimaryText || "#fff"} />
            </SocialButton>
          </a>
          <a href={theme && theme.instagramLink || objUrlInstagram[urlHref]} target="_blank" rel="noopener noreferrer">
            <SocialButton bgColor={theme && theme.buttonPrimaryBackgound} className="opacity">
              <FaInstagram size={22} color={theme && theme.buttonPrimaryText || "#fff"} />
            </SocialButton>
          </a>
        </SocialNetworksContainer>
      </Content>
      <CopyRightContainer className="total-center" bgColor={theme && theme.footerSecondaryBackground}>
        <p style={{ color:`${theme && theme.colorParagraph}` }}>
          Copyright <b style={{ color:`${theme && theme.colorTitle}` }}>{theme && theme.name ? theme.name : ""}</b>. All rights reserved.
        </p>
      </CopyRightContainer>
    </Container>
  );
}
